'use client';

import React from 'react';
import { getMediaData } from '@/lib/utils/media.utils';
import { AnimatedTitle } from '../../animated-title';
import type { LandscapeSketchbook } from '@/types';
import Image from 'next/image';

interface LandscapeSketchbookProps {
  layout: LandscapeSketchbook;
}
export const Landscape_Sketchbook: React.FC<LandscapeSketchbookProps> = ({ layout }) => {
  return (
    <section className="w-full">
      <div className="p-[15px] rounded-md bg-white mb-[12px] flex flex-col justify-between relative pt-8">
        {layout.title ? (
          <div className="absolute top-[15px] left-[15px] text-gray-500">
            <AnimatedTitle>[ {layout.title} ]</AnimatedTitle>
          </div>
        ) : (
          ''
        )}
        {layout.titleRightTop ? (
          <div className="absolute top-[15px] right-[15px] text-gray-500">
            <AnimatedTitle marginClass="mb-0">[ {layout.titleRightTop} ]</AnimatedTitle>
          </div>
        ) : (
          ''
        )}

        <div className="w-full grid grid-cols-1 md:grid-cols-4 lg:grid-cols-10 gap-2 mt-6">
          {layout.images?.map((image, index) => {
            const imageUrl = typeof image !== 'number' ? getMediaData(image) : null;
            if (!imageUrl) return null;

            return (
              <div key={index} className="col-span-1 aspect-square overflow-hidden rounded-md">
                <Image
                  src={imageUrl.url}
                  width={imageUrl.width}
                  height={imageUrl.height}
                  alt=""
                  className="w-full h-full object-contain object-center rounded-md"
                />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
